export default __webpack_public_path__ + "1c63531fd75a95da2a7cc03e59ba3e13.png";